import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateDifference',
  standalone: false,
})
export class DateDifferencePipe implements PipeTransform {
  public transform(value: moment.Moment | string, baseDate?: moment.Moment): moment.Duration {
    baseDate = !baseDate ? moment() : baseDate;
    return value
      ? moment.duration(Math.abs(typeof value === 'string' ? moment(value).diff(baseDate) : value.diff(baseDate)))
      : moment.duration('00:00:00');
  }
}
